import { trackingShape, withTracking } from "../../context";

type Props = {
  label: string;
  disabled?: boolean;
  onChange: $TSFixMeFunction;
  checked: boolean;
  option: string;
  tracking: trackingShape;
};

export function SearchOptionItem({
  label,
  disabled,
  onChange,
  checked,
  option,
  tracking,
}: Props) {
  const handleOnChange = (event: $TSFixMe) => {
    onChange(option, event.target.checked);
    const eventProps = {
      optionItemName: label,
      actionType: event.target.checked ? "checked" : "unchecked",
    };
    tracking?.trackEvent("Search-Option-Item-clicked", eventProps);
  };

  return (
    <li className="list-inline-item">
      <input
        id={`${label}-checkbox`}
        name={label}
        checked={checked}
        type="checkbox"
        disabled={disabled}
        onChange={handleOnChange}
      />
      <label htmlFor={`${label}-checkbox`}>{label}</label>
    </li>
  );
}
export default withTracking(SearchOptionItem);
